import { remove, screenPresets } from 'presets/data/queryKeyFactory';
import { Preset } from 'presets/interfaces';
import { removePreset } from 'presets/sources/removePreset';
import { useMutation, useOptimisticUpdate } from 'query';

export const useRemovePreset = (screenKey: string) => {
  const { onMutate, onError, onSettled } = useOptimisticUpdate({
    queryKey: screenPresets(screenKey),
    optimisticUpdate: (changedData: Preset, previousData: Preset[]) => {
      return (previousData as Preset[]).filter(
        preset => preset.id !== changedData.id
      );
    },
  });
  const removeMutation = useMutation(remove(), removePreset, {
    successMessage: () => `Preset removed`,
    refresh: false,
    onMutate,
    onError,
    onSettled,
  });

  return [removeMutation.mutateAsync, removeMutation];
};
